import { useState, useEffect } from 'react';
import { invoiceLineItemDispensesTableViewAtom } from './invoice_line_item_dispenses_atoms';
import {
    invoiceLineItemDispensesAllColumnsView,
    invoiceLineItemDispensesColumnSpec,
} from './InvoiceLineItemDispensesTableSpec';
import { tblSpecLoadView } from '../../../core/table/tableViewsRepo';
import { useSetImmerAtom } from 'jotai-immer';

export function useInvoiceLineItemDispensesTableInit(): { init: boolean } {
    const [init] = useState(false);
    const setView = useSetImmerAtom(invoiceLineItemDispensesTableViewAtom);

    useEffect(() => {
        // Use tblSpecLoadView to convert spec to TblView
        const colSpec = invoiceLineItemDispensesColumnSpec();
        const viewSpec = invoiceLineItemDispensesAllColumnsView();
        const tblView = tblSpecLoadView(viewSpec.key, [viewSpec], colSpec, () => viewSpec);
        if (tblView) {
            setView(() => tblView);
        }
    }, [setView]);

    return { init };
}
